import { combineReducers } from 'redux';

import atualizarContato from './atualizarContato/reducer';
import pesquisarContato from './pesquisarContato/reducer';

export default combineReducers({
	atualizarContato,
	pesquisarContato,
});
